"use strict";
/**
 * @author OPt
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../ValidationLevel");

var ValidationResult_1 = require("../ValidationResult");

var Validator_1 = require("../Validator");

var moment = require("moment");
/**
 * Validator that checks whether the given date is older date than year 2050.
 */


var DateAfterInfiniteValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(DateAfterInfiniteValidator, _Validator_1$Validato);

  function DateAfterInfiniteValidator() {
    _classCallCheck(this, DateAfterInfiniteValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(DateAfterInfiniteValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(DateAfterInfiniteValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (!moment.isMoment(value)) {
        return new ValidationResult_1.ValidationError(DateAfterInfiniteValidator.DATE_INVALID_FORMAT);
      }

      if (value.isSameOrBefore(moment(new Date(2049, 12)))) {
        return new ValidationResult_1.ValidationSuccess(value);
      }

      return new ValidationResult_1.ValidationError(DateAfterInfiniteValidator.DATE_AFTER_INFINITE_ERROR);
    }
  }]);

  return DateAfterInfiniteValidator;
}(Validator_1.Validator);

exports.DateAfterInfiniteValidator = DateAfterInfiniteValidator;
DateAfterInfiniteValidator.DATE_INVALID_FORMAT = 'BAD_DATE_INVALID_FORMAT';
DateAfterInfiniteValidator.DATE_AFTER_INFINITE_ERROR = 'DATE_AFTER_INFINITE';